import { to } from './to'
import router from '~/router'

/**
 * Generates the necessary props to bind a Modal to the URL.
 * Automatically handles v-model behavior (modelValue / onUpdate:modelValue).
 * TODO: Add required `dialog` HTML and aria attributes here
 * @example <Modal v-bind="dialog('pod')">
 */

export const dialog = {
  /**
   * Link to a dialog flag in the URL query string
   * @param key
   * @param expectedValue
   * @example <Link v-bind="dialog.to('help')">
   * @example <Card v-bind="dialog.to('create', 'podcast-channel')">
   */
  to(key: string, expectedValue: string | null = null) {
    return {
      ...to(
        {
          query: {
            ...router.currentRoute.value.query,
            [key]: expectedValue
          }
        },
        { ariaCurrentValue: 'false' }
      ),
      'aria-haspopup': 'dialog',
      'modelValue': undefined as never,
      get 'aria-expanded'() {
        return expectedValue === null
          ? router.currentRoute.value.query[key] !== undefined
          : router.currentRoute.value.query[key] === expectedValue
      }
    } as const
  },

  /**
   * Sync Modal `v-model` with the current route query
   * @param key
   * @param expectedValue
   * @example <Modal v-bind="dialog.model('pod')">
   * @example <Modal v-bind="dialog.model('create', 'select')">
   */
  model(key: string, expectedValue: string | null = null) {
    return {
      get 'modelValue'() {
        return expectedValue === null
          ? router.currentRoute.value.query[key] !== undefined
          : router.currentRoute.value.query[key] === expectedValue
      },
      'onUpdate:modelValue': (isOpen?: boolean) => {
        const currentQuery = { ...router.currentRoute.value.query }

        if (isOpen) currentQuery[key] = expectedValue
        else delete currentQuery[key]

        router.push({ query: currentQuery })
      }
    }
  }
}
